import FontAwesome6 from './build/FontAwesome6';
export default FontAwesome6;
